export const TRANSLATE_INTO_JAPANESE = 'TRANSLATE_INTO_JAPANESE'
export const TRANSLATE_INTO_ENGLISH = 'TRANSLATE_INTO_ENGLISH'
export const INCREASE_FONT_SIZE = 'INCREASE_FONT_SIZE'
export const DECREASE_FONT_SIZE = 'DECREASE_FONT_SIZE'
export const OPEN_DRAWER = 'OPEN_DRAWER'
export const CLOSE_DRAWER = 'CLOSE_DRAWER'
